

// import { useQuery } from 'react-query';
// import axios from 'axios';
// import Papa from 'papaparse';
// import React from 'react';

// const fetchCsvData1 = async () => {
//   try {
//     const response = await axios.get('/assets/CSVs/categories.csv');
//     const { data } = response;
//     const parsedData = Papa.parse(data, { header: true }).data;
//     return parsedData;
//   } catch (error) {
//     throw new Error('Failed to fetch and parse CSV data');
//   }
// };

// export function CategoryCsvData() {
// const [categoryCSVQuery, setCategoryCSVQuery] = React.useState([]);
// const { data, isLoading1, isError1, error1 } = useQuery('CategoryCsvData', fetchCsvData1);
// React.useEffect(() => {
//   if (!isLoading1 && !isError1) {
//     // Ensure the data is not loading and there are no errors
//     setCategoryCSVQuery(data);
//   }
// }, [data, isLoading1, isError1]);

// return { categoryCSVQuery, isLoading1, isError1, error1 };
// }




import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Papa from 'papaparse';

const fetchCsvData1 = async () => {
  try {
    const response = await axios.get('/assets/CSVs/categories.csv');
    const { data } = response;
    const parsedData = Papa.parse(data, { header: true }).data;
    return parsedData;
  } catch (error) {
    throw new Error('Failed to fetch and parse CSV data');
  }
};

export function CategoryCsvData() {
  const [categoryCSVQuery, setCategoryCSVQuery] = useState([]);
  const [isLoading1, setIsLoading1] = useState(true);
  const [isError1, setIsError1] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setIsLoading1(true);
      setIsError1(null);
      try {
        const data = await fetchCsvData1();
        setCategoryCSVQuery(data);
      } catch (error) {
        setIsError1(error);
      } finally {
        setIsLoading1(false);
      }
    };

    loadData();
  }, []); // Empty dependency array means this useEffect runs once on mount

  return { categoryCSVQuery, isLoading1, isError1 };
}
